import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LayoutDashboard, MessageSquare, FileText, Settings, BookOpen, Layers, Users, LogOut, Activity, Sliders } from 'lucide-react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
export function Sidebar() {
  const {
    user,
    logout
  } = useAuth();
  const location = useLocation();
  if (!user) return null;
  const getNavItems = () => {
    switch (user.role) {
      case 'employee':
        return [{
          icon: MessageSquare,
          label: 'Chat',
          path: '/employee'
        }, {
          icon: FileText,
          label: 'My Forms',
          path: '/employee/forms'
        }];
      case 'hr':
        return [{
          icon: LayoutDashboard,
          label: 'Dashboard',
          path: '/hr/dashboard'
        }, {
          icon: Sliders,
          label: 'KPI Manager',
          path: '/hr/kpi/builder'
        }, {
          icon: FileText,
          label: 'Forms',
          path: '/hr/forms/builder'
        }, {
          icon: Settings,
          label: 'Settings',
          path: '/hr/settings'
        }];
      case 'management':
        return [{
          icon: LayoutDashboard,
          label: 'Executive View',
          path: '/mgmt/dashboard'
        }, {
          icon: BookOpen,
          label: 'Monthly Digest',
          path: '/mgmt/digest'
        }, {
          icon: Settings,
          label: 'Settings',
          path: '/mgmt/settings'
        }];
      case 'admin':
        return [{
          icon: BookOpen,
          label: 'Knowledge Base',
          path: '/admin/kb'
        }, {
          icon: Layers,
          label: 'Integrations',
          path: '/admin/integrations'
        }, {
          icon: Users,
          label: 'Roles & Users',
          path: '/admin/roles'
        }];
      default:
        return [];
    }
  };
  return <motion.aside initial={{
    x: -20,
    opacity: 0
  }} animate={{
    x: 0,
    opacity: 1
  }} className="w-64 h-screen fixed left-0 top-0 glass-panel border-r border-white/10 flex flex-col z-50" data-id="element-57">
      <div className="p-6 flex items-center space-x-3 border-b border-white/5" data-id="element-58">
        <div className="w-8 h-8 rounded-lg bg-accent flex items-center justify-center shadow-lg shadow-accent/20" data-id="element-59">
          <Activity className="text-background w-5 h-5" data-id="element-60" />
        </div>
        <span className="text-xl font-bold tracking-tight text-white" data-id="element-61">
          CoolerPulse
        </span>
      </div>

      <nav className="flex-1 py-6 px-3 space-y-1" data-id="element-62">
        {getNavItems().map(item => {
        const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
        return <NavLink key={item.path} to={item.path} className={({
          isActive
        }) => clsx('flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 group', isActive ? 'bg-accent/10 text-accent border border-accent/20' : 'text-secondary hover:text-white hover:bg-white/5')} data-id="element-63">
              <item.icon className={clsx('w-5 h-5 transition-colors', isActive ? 'text-accent' : 'text-secondary group-hover:text-white')} data-id="element-64" />
              <span className="font-medium" data-id="element-65">{item.label}</span>
              {isActive && <motion.div layoutId="activeIndicator" className="absolute left-0 w-1 h-8 bg-accent rounded-r-full" data-id="element-66" />}
            </NavLink>;
      })}
      </nav>

      <div className="p-4 border-t border-white/5" data-id="element-67">
        <div className="flex items-center space-x-3 px-4 py-3 mb-2" data-id="element-68">
          <div className="w-8 h-8 rounded-full bg-surfaceHighlight flex items-center justify-center text-sm font-bold text-white border border-white/10" data-id="element-69">
            {user.name.charAt(0)}
          </div>
          <div className="flex-1 min-w-0" data-id="element-70">
            <p className="text-sm font-medium text-white truncate" data-id="element-71">
              {user.name}
            </p>
            <p className="text-xs text-secondary capitalize" data-id="element-72">{user.role}</p>
          </div>
        </div>
        <button onClick={logout} className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-secondary hover:text-danger transition-colors rounded-lg hover:bg-danger/10" data-id="element-73">
          <LogOut className="w-4 h-4" data-id="element-74" />
          <span data-id="element-75">Sign Out</span>
        </button>
      </div>
    </motion.aside>;
}